const env = 'developmentOnline';

const NODE_ENV = env;
export default NODE_ENV;
